var q = (_, m, u) => new Promise((e, o) => {
  var v = (d) => {
    try {
      i(u.next(d));
    } catch (s) {
      o(s);
    }
  }, r = (d) => {
    try {
      i(u.throw(d));
    } catch (s) {
      o(s);
    }
  }, i = (d) => d.done ? e(d.value) : Promise.resolve(d.value).then(v, r);
  i((u = u.apply(_, m)).next());
});
import { a as A, m as I, q as H, u as z, o as B, b as E, c as l, e as n, F as b, h as y, w, g as V, p as K, f, i as C, t as S, k, as as Q, x as W, at as X, j as Y, l as h } from "./define-element-XpjsV6s1.js";
import { u as Z } from "./use-club-A3ZrZZcp.js";
import { u as ee } from "./use-user-CwEHAZOt.js";
import { B as D } from "./Button-D5lKR5Sd.js";
import { _ as j } from "./_plugin-vue_export-helper-CHgC5LLL.js";
import { L as te } from "./Loader-CeIJU_1y.js";
import { L as ae } from "./LoginForm-D68uOH8H.js";
import { I as T } from "./Input-yplyeePD.js";
import { S as se } from "./Select-CfkMpX3N.js";
import { D as le } from "./DateOfBirth-C57dVBDY.js";
import { A as oe } from "./Address-QnUa_uo4.js";
import { u as ne } from "./use-states-T4YLdFAy.js";
import { u as re } from "./use-addresses-Wp77HwbF.js";
import { i as R } from "./utils-CMsllPx8.js";
/* empty css                                                                      */
import "./use-cart-D8NOb7eE.js";
const ie = ["value"], ue = { key: 0 }, de = {
  key: 0,
  class: "error"
}, fe = { class: "grouped" }, me = {
  __name: "ShippingForm",
  props: {
    inheritStyle: {
      type: String,
      default: "all"
    },
    saveText: {
      type: String,
      default: "Save Address"
    }
  },
  emits: ["save"],
  setup(_, { emit: m }) {
    const u = m, e = A({
      title: "",
      first_name: "",
      last_name: "",
      phone: "",
      email: "",
      birthday: "",
      country: "US",
      businessName: "",
      address: "",
      address2: "",
      city: "",
      state: "",
      zip: "",
      default: !1
    }), o = A(!1), v = A({
      title: !1,
      first_name: !1,
      last_name: !1,
      phone: !1,
      email: !1,
      birthday: !1,
      country: !1,
      address: !1,
      address2: !1,
      city: !1,
      state: !1,
      zip: !1
    }), r = _, { data: i, isPending: d } = ne(), {
      data: s,
      selectedAddressId: p,
      selectedAddress: c,
      createAddressMutation: F,
      deleteAddressMutation: M
    } = re(), { mutate: N } = F, { mutate: P } = M, U = I(() => s.value && s.value.length > 0), x = I(() => p.value == "new" ? !0 : !U.value);
    function L() {
      c.value ? u("save") : J(e.value) && (N(e.value), u("save"));
    }
    function J(g) {
      const t = [
        "title",
        "first_name",
        "last_name",
        "phone",
        "email",
        "birthday",
        "country",
        "address",
        "city",
        "state",
        "zip"
      ];
      return o.value = !1, t.forEach((a) => {
        R(g[a]) && (v.value[a] = !0, o.value = !0);
      }), !o.value;
    }
    function $() {
      if (U.value && R(p.value)) {
        const g = s.value.find(
          (t) => t.default == 1
        );
        g ? p.value = g.id : p.value = s.value[0].id;
      }
    }
    H(s, () => {
      $();
    });
    function O(g) {
      return q(this, null, function* () {
        yield P(g), p.value = "", $();
      });
    }
    const G = z("container");
    return B(() => {
      E(G.value, r.inheritStyle);
    }), (g, t) => (l(), n("form", {
      class: "offset-shipping-form",
      ref: "container",
      onSubmit: W(L, ["prevent"])
    }, [
      U.value ? (l(), n(b, { key: 0 }, [
        y(se, {
          label: "Choose an Address",
          modelValue: f(p),
          "onUpdate:modelValue": t[0] || (t[0] = (a) => Q(p) ? p.value = a : null),
          required: ""
        }, {
          default: w(() => [
            t[12] || (t[12] = V("option", { value: "new" }, "Use New Address", -1)),
            (l(!0), n(b, null, K(f(s), (a) => (l(), n("option", {
              value: a.id,
              key: a.id
            }, [
              C(S(a.title) + " ", 1),
              a.default == 1 ? (l(), n(b, { key: 0 }, [
                C("(Primary)")
              ], 64)) : k("", !0)
            ], 8, ie))), 128))
          ]),
          _: 1,
          __: [12]
        }, 8, ["modelValue"]),
        f(c) ? (l(), n("div", ue, [
          V("p", null, S(f(c).address), 1),
          V("p", null, S(f(c).city) + ", " + S(f(c).city) + " " + S(f(c).zip), 1),
          y(D, {
            onClick: t[1] || (t[1] = (a) => O(f(c).id)),
            variant: "alt"
          }, {
            default: w(() => t[13] || (t[13] = [
              C("Remove Address", -1)
            ])),
            _: 1,
            __: [13]
          })
        ])) : k("", !0)
      ], 64)) : k("", !0),
      x.value ? (l(), n(b, { key: 1 }, [
        o.value ? (l(), n("p", de, "Please fill out all required fields.")) : k("", !0),
        V("div", fe, [
          y(T, {
            type: "text",
            label: "First Name",
            modelValue: e.value.first_name,
            "onUpdate:modelValue": t[2] || (t[2] = (a) => e.value.first_name = a),
            required: "",
            floating: !0
          }, null, 8, ["modelValue"]),
          y(T, {
            type: "text",
            label: "Last Name",
            modelValue: e.value.last_name,
            "onUpdate:modelValue": t[3] || (t[3] = (a) => e.value.last_name = a),
            required: "",
            floating: !0
          }, null, 8, ["modelValue"])
        ]),
        V("div", null, [
          y(le, {
            modelValue: e.value.birthday,
            "onUpdate:modelValue": t[4] || (t[4] = (a) => e.value.birthday = a),
            required: ""
          }, null, 8, ["modelValue"])
        ]),
        y(oe, {
          country: e.value.country,
          "onUpdate:country": t[5] || (t[5] = (a) => e.value.country = a),
          address: e.value.address,
          "onUpdate:address": t[6] || (t[6] = (a) => e.value.address = a),
          address2: e.value.address2,
          "onUpdate:address2": t[7] || (t[7] = (a) => e.value.address2 = a),
          city: e.value.city,
          "onUpdate:city": t[8] || (t[8] = (a) => e.value.city = a),
          state: e.value.state,
          "onUpdate:state": t[9] || (t[9] = (a) => e.value.state = a),
          zip: e.value.zip,
          "onUpdate:zip": t[10] || (t[10] = (a) => e.value.zip = a),
          validStates: f(i)
        }, null, 8, ["country", "address", "address2", "city", "state", "zip", "validStates"]),
        y(T, {
          type: "tel",
          label: "Phone",
          modelValue: e.value.phone,
          "onUpdate:modelValue": t[11] || (t[11] = (a) => e.value.phone = a),
          required: "",
          floating: !0
        }, null, 8, ["modelValue"])
      ], 64)) : k("", !0)
    ], 544));
  }
}, pe = /* @__PURE__ */ j(me, [["__scopeId", "data-v-9e60cec3"]]), ve = {
  ref: "container",
  class: "offset-modal",
  "aria-label": "Dialog"
}, ce = {
  __name: "Modal",
  emits: ["close"],
  setup(_, { emit: m }) {
    const u = m, e = z("container");
    let o = null;
    function v() {
      u("close");
    }
    return B(() => {
      var r, i;
      E(e.value), o = document.activeElement, (r = e.value) == null || r.addEventListener("close", v), (i = e.value) == null || i.showModal();
    }), X(() => {
      var r;
      (r = e.value) == null || r.removeEventListener("close", v), o && typeof o.focus == "function" && o.focus();
    }), (r, i) => (l(), n("dialog", ve, [
      V("button", {
        type: "button",
        class: "offset-modal-close",
        "aria-label": "Close",
        onClick: i[0] || (i[0] = (d) => {
          var s;
          return (s = e.value) == null ? void 0 : s.close();
        })
      }, " × "),
      Y(r.$slots, "default", {}, void 0, !0)
    ], 512));
  }
}, ye = /* @__PURE__ */ j(ce, [["__scopeId", "data-v-42b0d1df"]]), ge = {
  ref: "container",
  class: "offset-club-button"
}, Ee = {
  __name: "ClubButton",
  props: {
    inheritStyle: {
      type: String,
      default: "all"
    },
    clubSlug: String,
    joinText: {
      type: String,
      default: "Join the club"
    },
    editText: {
      type: String,
      default: "Edit Club Membership"
    }
  },
  setup(_) {
    const m = _, {
      isPending: u,
      data: e,
      loginMutation: o,
      logoutMutation: v
    } = ee(), { mutate: r } = o, { mutate: i } = v, d = A(!1), s = A(!1), { clubMutation: p } = Z(m.clubSlug), { mutate: c, isPending: F } = p;
    function M() {
      s.value = !0;
    }
    function N() {
      console.log("continueToPayment");
    }
    const P = z("container");
    return B(() => {
      E(P.value, m.inheritStyle);
    }), (U, x) => (l(), n("div", ge, [
      y(D, { onClick: M }, {
        default: w(() => [
          d.value ? (l(), n(b, { key: 0 }, [
            C(S(m.editText), 1)
          ], 64)) : (l(), n(b, { key: 1 }, [
            C(S(m.joinText), 1)
          ], 64))
        ]),
        _: 1
      }),
      s.value ? (l(), h(ye, {
        key: 0,
        onClose: x[0] || (x[0] = (L) => s.value = !1)
      }, {
        default: w(() => [
          f(e) ? (l(), h(pe, {
            key: 1,
            onSave: N
          })) : (l(), n(b, { key: 0 }, [
            f(u) ? (l(), h(te, { key: 0 })) : (l(), h(ae, {
              key: 1,
              "redirect-url": ""
            }))
          ], 64))
        ]),
        _: 1
      })) : k("", !0)
    ], 512));
  }
};
export {
  Ee as _
};
